import React from "react"
import { Modal, Button, Typography, Box, IconButton } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline"

interface UnsavedChangesModalProps {
  open: boolean
  onConfirm: () => void
  onCancel: () => void
  title?: string
  message?: string
}

const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({
  open,
  onConfirm,
  onCancel,
  title = "Unsaved Changes",
  message = "You have unsaved changes in Resource Budget that will be lost. Do you want to continue?",
}) => {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      aria-labelledby="unsaved-changes-modal"
      aria-describedby={title}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          borderRadius: "8px",
          transform: "translate(-50%, -50%)",
          width: 450,
          bgcolor: "#fff",
          boxShadow: 24,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            paddingBottom: "30px",
            paddingTop: "50px",
          }}
        >
          <ErrorOutlineIcon color="error" sx={{ fontSize: "50px" }} />
          <IconButton
            sx={{
              position: "absolute",
              top: 2,
              right: 2,
            }}
            onClick={onCancel}
          >
            <CloseIcon />
          </IconButton>

          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: "bold",
              textAlign: "center",
              mx: "20px",
            }}
          >
            {title}
          </Typography>
          {message && (
            <Typography
              sx={{
                fontSize: "14px",
                color: "#707070",
                textAlign: "center",
                mx: "20px",
              }}
            >
              {message}
            </Typography>
          )}
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: "20px",
          }}
        >
          <Button
            variant="outlined"
            sx={{
              textTransform: "none",
              fontWeight: "bold",
              color: "#3366D6",
              px: "60px",
              display: "flex",
              mb: "30px",
              borderColor: "#3366D6",
            }}
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{
              textTransform: "none",
              fontWeight: "bold",
              color: "#fff",
              px: "35px",
              display: "flex",
              mb: "30px",
            }}
            onClick={onConfirm}
          >
            Continue
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}

export default UnsavedChangesModal
